import axios from "axios";
import config from '../environment/config';
import { authHeader } from "./auth.header";

const API_URL = config.API_URL;

export const getProductById = async (productId) => {
  try {
    return (await axios.get(`${API_URL}api/seo-product-details/${productId}`, {
      headers: { 'Content-Type': 'application/json' }
    })).data;
  } catch (error) {
    console.error('Error occurred in getProductById():', error);
    throw error;
  }
};

export const getAllProducts = async (categoryId) => {
  try {
    return (await axios.get(`${API_URL}api/seo-product-details/category/${categoryId}`, {
      headers: { 'Content-Type': 'application/json' }
    })).data;
  } catch (error) {
    console.error('Error occurred in getAllProducts():', error);
    throw error;
  }
};

export const getFeatureByProduct = async (productId) => {
  try {
    return (await axios.get(`${API_URL}api/seo-product-features/product/${productId}`, {
      headers: { 'Content-Type': 'application/json' }
    })).data;
  } catch (error) {
    console.error('Error occurred in getFeatureByProduct():', error);
    throw error;
  }
};

export const getProductFeatures = async () => {
  try {
    return (await axios.get(`${API_URL}api/seo-product-features`, {
      headers: { 'Content-Type': 'application/json' }
    })).data;
  } catch (error) {
    console.error('Error occurred in getFeatureByProduct():', error);
    throw error;
  }
};

export const getAllCategory = async () => {
  try {
    return (await axios.get(`${API_URL}api/categories`, {
      headers: { 'Content-Type': 'application/json' }
    })).data;
  } catch (error) {
    console.error('Error occurred in getAllCategory():', error);
    throw error;
  }
};

export const getPlansByProduct = async (productId) => {
  try {
    return (await axios.get(`${API_URL}api/seo-product-plans/product/${productId}`, {
      headers: { 'Content-Type': 'application/json' }
    })).data;
  } catch (error) {
    console.error('Error in getPlansByProduct():', error);
    throw error;
  }
};

export const getSpecificationsByProduct = async (productId) => {
  try {
    return (await axios.get(`${API_URL}api/seo-product-specifications/product/${productId}`, {
      headers: { 'Content-Type': 'application/json' }
    })).data;
  } catch (error) {
    console.error('Error in getSpecificationsByProduct():', error);
    throw error;
  }
};

export const getReviewsByProduct = async (productId) => {
  try {
    return (await axios.get(`${API_URL}api/seo-product-reviews/product/${productId}`, {
      headers: { 'Content-Type': 'application/json' }
    })).data;
  } catch (error) {
    console.error('Error in getReviewsByProduct():', error);
    throw error;
  }
};

export const getSupportByProduct = async (productId) => {
  try {
    return (await axios.get(`${API_URL}api/seo-product-supports/product/${productId}`, {
      headers: { 'Content-Type': 'application/json' }
    })).data;
  } catch (error) {
    console.error('Error in getSupportByProduct():', error);
    throw error;
  }
};